export class LoggedOutAction {
  public static readonly type = '[Authentication] LoggedOutAction';
}
